import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { CSVLink } from "react-csv";
import Image from "mui-image";
import csv from "src/img/csv.png";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import { Chart, registerables } from "chart.js";
import "chartjs-plugin-datalabels";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getCostsOfAllTicketsByAssetId } from "src/apis/tickets";
import { ReportsColumnFields, ticketStatuses } from "src/util/utility_enums";
import { getReportDetail } from "src/apis/tickets";
import pdf from 'src/img/pdf.png';
import GeneratePDFContainer from "../GeneratePDFContainer";
Chart.register(...registerables);

const DataGridComponent = ({ rows, siteName,pdfGenerate,assetId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const handleConfirmButton = () => {
    setIsOpen(false);
  };

  const columns = [
    { field: "name", headerName: "Name", flex: 1 },
    { field: "date", headerName: "Date", flex: 1 },
    { field: "status", headerName: "Status", flex: 1 },
    { field: "timeSpent", headerName: "Time spent to solve it", flex: 1 },
    { field: "cost", headerName: "Cost", flex: 1 },
  ];

  // Prepare data for CSV export
  const csvData = rows.map((row) => ({
    name: row.name,
    date: row.date,
    status: row.status,
    timeSpent: row.timeSpent,
    cost: row.cost,
  }));
  // Calculate the sum of each column
  const columnSums = {};
  columns.forEach((column) => {
    const fieldName = column.field;
    switch (fieldName) {
      case ReportsColumnFields.SITE:
        columnSums[fieldName] = siteName ?? "";
        break;
      case ReportsColumnFields.TICKET:
        columnSums[fieldName] = rows.reduce(
          (acc, row) => acc + Number(row[fieldName]),
          0
        );
        break;
      case ReportsColumnFields.TIMESPENT:
        const totalHours = rows.reduce((acc, row) => {
          const hours = parseFloat(row[fieldName]);
          if (!isNaN(hours)) {
            return acc + hours;
          }
          return acc;
        }, 0);
        columnSums[fieldName] = totalHours;
        break;
      case ReportsColumnFields.COST:
        const totalCost = rows.reduce((acc, row) => {
          const cost = parseFloat(row[fieldName]);
          if (!isNaN(cost)) {
            return acc + cost;
          }
          return acc;
        }, 0);
        columnSums[fieldName] = totalCost;
        break;
      default:
        columnSums[fieldName] = "";
        break;
    }
  });

  return (
    <div style={{ width: "100%", marginBottom: 15 }}>
      <div className="datePicker">
        <span onClick={() => setIsOpen(!isOpen)}>
          <CalendarTodayIcon />
        </span>
        <span>
          {" "}
          {startDate.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })}{" "}
          -
          {endDate.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })}
        </span>
      </div>
      {isOpen && (
        <div className="dateDropdown">
          <div className="startDatePicker">
            <span className="fromTo">From:</span>{" "}
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd/MM/yyyy"
            />
          </div>
          <div className="endDatePicker">
            <span className="fromTo">To:</span>{" "}
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
            />
          </div>
          <div className="confirmButton">
            <ButtonPolicy color="primary" onClick={handleConfirmButton}>
              Confirm
            </ButtonPolicy>
          </div>
        </div>
      )}
      <DataGrid
        className="reportDataGrid"
        columns={columns}
        rows={rows}
        pagination
      />
      <div className="totalAmount">
        <table>
          <tbody>
            <tr>
              <td>Total:</td>
              <td>{columnSums.site}</td>
              <td>{columnSums["ticket"]} Tickets</td>
              <td>{columnSums["timeSpent"].toFixed(2)} Hours</td>
              <td>{columnSums["cost"].toFixed(2)} €</td>
              <td>
              <div className='csvImageHolder'>
                      <Image src={pdf} onClick={()=> pdfGenerate(assetId)}/>
                    </div>
              </td>
              <td>
                <span className="excelFile">
                  <CSVLink
                    data={csvData}
                    headers={columns.map((column) => ({
                      label: column.headerName,
                      key: column.field,
                    }))}
                  >
                    <div className="csvImageHolder">
                      <Image src={csv} />
                    </div>
                  </CSVLink>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

const ReportHistoryRowDetails = ({ rowData }) => {
  const siteName = rowData.site;
  const fetchData = async (id) => {
    try {
      const assetReoprts = await getCostsOfAllTicketsByAssetId(id);
      return assetReoprts;
    } catch (error) {
      console.error(error);
    }
  };

  const fillTable = async (id) => {
    try {
      const assetReports = await fetchData(id);
      if (assetReports) {
        let id = 0;
        const modifiedRows = assetReports.map((report) => ({
          id: id++,
          name: report.itemSn,
          date: report.siteName,
          status: ticketStatuses[report.ticketStatus - 1].name,
          timeSpent:
            report.timeSpentToSolve !== null ? report.timeSpentToSolve : "N.A",
          cost:
            report.isOnerous === true
              ? report.feeAmountProposal
              : "Covered by contract with cost : " + report.feeAmountProposal,
        }));
        setRows(modifiedRows);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fillTable(rowData.id);
  }, [rowData]);

  console.log("row details : ", rowData);
  const [rows, setRows] = useState([]);
  const fetchReportDetail = async (id) => {
        
    try {
       await getReportDetail(id)
   } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="datagrid-container">
      <DataGridComponent rows={rows} siteName={siteName} pdfGenerate={fetchReportDetail} assetId={rowData.id}/>
    </div>
  );
};

export default ReportHistoryRowDetails;
